import { render } from "./jumpLink.vue?vue&type=template&id=75cfdfcf&scoped=true"
import script from "./jumpLink.vue?vue&type=script&lang=js"
export * from "./jumpLink.vue?vue&type=script&lang=js"

import "./jumpLink.vue?vue&type=style&index=0&id=75cfdfcf&scoped=true&lang=less"
import "./jumpLink.vue?vue&type=style&index=1&id=75cfdfcf&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cfdfcf"]])

export default __exports__